import { useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { caseCheckRouteConfig } from './caseCheckRouteConfig';

// Chooses route groups based on current path.
export const useChooseRouteConfig = (routeConfig) => {
  const location = useLocation();
  const [config, setConfig] = useState(routeConfig);
  useEffect(() => {
    const match = matchPath(location.pathname, {
      path: '*/case-check*',
    });
    if (match) {
      setConfig(caseCheckRouteConfig);
    } else if (routeConfig) {
      setConfig(routeConfig);
    }
  }, [location]);

  return config;
};
